import { useNavigate } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import usePageSeo from '../hooks/usePageSeo';
import logoIcon from '../assets/logo-icon.png';
import './LegalPages.css';

function AccessibilityStatementPage() {
  const navigate = useNavigate();

  usePageSeo({
    title: 'הצהרת נגישות',
    description:
      'הצהרת הנגישות של CliniKit – מערכת ניהול קליניקות למטפלים בישראל. האתר עומד בתקן הישראלי 5568 (WCAG 2.0 רמה AA).',
    path: '/accessibility',
  });

  return (
    <div className="legal-page">
      <div className="legal-header">
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          <ArrowRight size={20} weight="bold" />
          <span>חזרה</span>
        </button>
        <div className="legal-logo-group">
          <span className="legal-logo-text">CliniKit</span>
          <img src={logoIcon} alt="CliniKit" className="legal-logo-icon" />
        </div>
      </div>

      <div className="legal-content">
        <h1>הצהרת נגישות</h1>
        <div className="legal-text">
          <p>
            חברת "קליניקיט" רואה חשיבות רבה במתן שירות שוויוני לכלל הגולשים
            ובהנגשת האתר לאנשים עם מוגבלות, מתוך אמונה כי לכל אדם מגיעה הזכות
            לחיות בשוויון, כבוד, נוחות ועצמאות.
          </p>

          <p>1. רמת הנגישות באתר</p>
          <p>
            1.1. אתר זה הונגש בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות
            (התאמות נגישות לשירות), התשע"ג-2013.
          </p>
          <p>
            1.2. ההנגשה בוצעה בהתאם להמלצות התקן הישראלי (ת"י 5568) לנגישות תכנים
            באינטרנט ברמת AA ולמסמך WCAG 2.0 הבינלאומי.
          </p>
          <p>
            1.3. האתר נבדק ונתמך בדפדפנים הנפוצים (Chrome, Safari, Firefox, Edge)
            ובשימוש בטכנולוגיות מסייעות (קוראי מסך).
          </p>

          <p>2. אמצעי הנגישות באתר</p>
          <p>2.1. באתר מוצב תפריט נגישות (סמל בפינה השמאלית התחתונה) המאפשר:</p>
          <p>• הגדלה והקטנה של גודל הטקסט</p>
          <p>• ניגודיות גבוהה והיפוך צבעים</p>
          <p>• הצגת האתר בגווני אפור</p>
          <p>• הדגשת קישורים</p>
          <p>• מעבר לפונט קריא</p>
          <p>• עצירת אנימציות ותנועה</p>
          <p>• הגדלת סמן העכבר</p>
          <p>• איפוס כלל ההגדרות</p>
          <p>
            2.2. באתר קיימת תמיכה בניווט מקלדת מלא, בסימון פוקוס ברור ובמבנה
            כותרות סמנטי לקוראי מסך.
          </p>
          <p>2.3. הגדרות הנגישות שנבחרו נשמרות במכשיר המשתמש בין הביקורים.</p>

          <p>3. הסדרי נגישות ופניות</p>
          <p>
            3.1. אנו עושים כל מאמץ לשמור על נגישות האתר ולשפרו באופן מתמיד. יחד עם
            זאת, ייתכן שיימצאו חלקים או רכיבים שטרם הונגשו במלואם.
          </p>
          <p>
            3.2. אם נתקלת בבעיית נגישות באתר, או שיש לך הצעה לשיפור, נשמח שתפנה
            אלינו ונטפל בפנייתך בהקדם האפשרי.
          </p>

          <p>4. פרטי רכז הנגישות</p>
          <p>• שם: יניב סולטן</p>
          <p>• דוא"ל: office@clinikit.co.il</p>
          <p>• טלפון: 054-3073737</p>
          <p>• שעות מענה: א'-ה' 09:00-18:00</p>

          <p>5. עדכון ההצהרה</p>
          <p>
            5.1. הצהרת נגישות זו עודכנה בחודש יולי 2026. אנו ממשיכים לפעול לשיפור
            נגישות האתר כחלק ממחויבותנו לאפשר שימוש בו לכלל האוכלוסייה, לרבות
            אנשים עם מוגבלות.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AccessibilityStatementPage;
